import { Injectable } from '@angular/core';
import * as _ from 'underscore';

@Injectable()
export class PaginationService {
  constructor() { }

  getPager(
    totalItems: number,
    currentPage: number,
    pageSize: number, targetpage: number
  ) {
    // calculate total pages
    const totalPages = Math.ceil(totalItems / pageSize);

    let startPage: number, endPage: number;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }

    let startIndex;
    let endIndex;
    if (targetpage == 0) {
      // calculate start and end item indexes
      startIndex = 0;
      endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
    } else {
      startIndex = (targetpage - 1) * pageSize;
      //startIndex= startIndex+1
      endIndex = Math.min(startIndex + pageSize - 1, endPage == targetpage ? totalItems : totalItems - 1);
    }


    // create an array of pages to ng-repeat in the pager control
    const pages = _.range(startPage, endPage + 1);

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }
}
